export const omitFromObject = (
  object: { [key: string]: unknown },
  key: string
): Record<string, unknown> => {
  const { [key]: omit, ...rest } = object;
  return rest;
};
